import { Controller } from "@hotwired/stimulus"
import type { TurboBeforeFetchRequestEvent, TurboSubmitStartEvent } from "@hotwired/turbo"
import Confirmation from "../../confirmation"
import SelectionToolbarController from "../selection_toolbar_controller"

export default class extends Controller {
  static targets = ["deleteSelectedBtn", "shareForm", "toolbar"]

  declare readonly deleteSelectedBtnTarget: HTMLButtonElement
  declare readonly shareFormTarget?: HTMLFormElement
  declare readonly toolbarTarget: HTMLElement

  async confirmDelete(event: TurboBeforeFetchRequestEvent) {
    event.preventDefault()

    if (await Confirmation.confirmDelete("this template")) {
      event.detail.resume(null)
    }
  }

  deleteSelectedBtnTargetConnected(el: HTMLButtonElement) {
    const form = el.closest("form")
    if (!form) {
      return
    }

    form.addEventListener("turbo:before-fetch-request", async (event: TurboBeforeFetchRequestEvent) => {
      event?.preventDefault()

      const selectionToolbar = this.getSelectionToolbarController()
      const ids = selectionToolbar?.selectedIds() || []
      const count = ids.length

      if (await Confirmation.confirm({
        text: `Are you sure you want to delete ${count} ${count === 1 ? 'template' : 'templates'}?`,
        confirmButtonText: "Yes, delete!",
        type: "danger"
      })) {
        event.detail.resume(null)
      } else {
        selectionToolbar?.clearSelected()
      }
    })

    form.addEventListener("turbo:submit-start", (event: TurboSubmitStartEvent) => {
      const selectionToolbar = this.getSelectionToolbarController()
      const ids = selectionToolbar?.selectedIds() || []
      ids.forEach(id => {
        event.detail.formSubmission.fetchRequest.body
          .append("ids[]", id)
      })
    })
  }

  shareFormTargetConnected(el: HTMLFormElement) {
    el.addEventListener("turbo:submit-start", (event: TurboSubmitStartEvent) => {
      if (!el.action.includes("update_selected_visibility")) {
        return
      }

      const selectionToolbar = this.getSelectionToolbarController()
      const ids = selectionToolbar?.selectedIds() || []
      ids.forEach(id => {
        event.detail.formSubmission.fetchRequest.body
          .append("ids[]", id)
      })
    })
  }

  getSelectionToolbarController(): SelectionToolbarController | null {
    return SelectionToolbarController.getInstance(this.toolbarTarget)
  }
}
